import React from "react";
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Fapugo Barbershop - Επαγγελματικό Κουρείο και Περιποίηση</title>
        <meta
          name="description"
          content="Fapugo Barbershop - Επαγγελματικές υπηρεσίες κουρέματος και περιποίησης. Ανακαλύψτε τις τελευταίες τάσεις στο ανδρικό στυλ και grooming."
        />
      </Helmet>

      <div className="policy-container">
        <div className="policy-content">
          <h1>Πολιτική Επιστροφών και Ακυρώσεων</h1>
          <p className="last-updated">
            Τελευταία ενημέρωση: {new Date().toLocaleDateString("el-GR")}
          </p>

          <section>
            <h2>1. Γενικές Πληροφορίες</h2>
            <p>
              Στο Fapugo Barbershop, στόχος μας είναι η πλήρης ικανοποίησή σας
              με τις υπηρεσίες μας. Αυτή η πολιτική επιστροφών και ακυρώσεων
              περιγράφει τα δικαιώματά σας και τις υποχρεώσεις μας σχετικά με
              τις επιστροφές χρημάτων και τις ακυρώσεις ραντεβού.
            </p>
          </section>

          <section>
            <h2>2. Πολιτική Ακύρωσης Ραντεβού</h2>

            <h3>2.1 Ακυρώσεις με Πλήρη Επιστροφή</h3>
            <p>
              Μπορείτε να ακυρώσετε το ραντεβού σας και να λάβετε πλήρη
              επιστροφή χρημάτων υπό τις ακόλουθες προϋποθέσεις:
            </p>
            <ul>
              <li>
                Ακύρωση τουλάχιστον 24 ώρες πριν από την προγραμματισμένη ώρα
              </li>
              <li>Ειδοποίηση μέσω του ιστότοπου, email ή τηλεφώνου</li>
              <li>Λήψη επιβεβαίωσης ακύρωσης από εμάς</li>
            </ul>

            <h3>2.2 Ακυρώσεις με Χρέωση</h3>
            <p>
              Για ακυρώσεις που πραγματοποιούνται εντός 24 ωρών πριν από το
              ραντεβού ισχύουν τα εξής:
            </p>
            <ul>
              <li>
                <strong>12-24 ώρες πριν:</strong> Χρέωση 50% της αξίας της
                υπηρεσίας
              </li>
              <li>
                <strong>Λιγότερο από 12 ώρες:</strong> Χρέωση 75% της αξίας της
                υπηρεσίας
              </li>
              <li>
                <strong>Μη εμφάνιση (No-show):</strong> Χρέωση 100% της αξίας
                της υπηρεσίας
              </li>
            </ul>

            <h3>2.3 Εξαιρέσεις</h3>
            <p>Δεν θα επιβληθεί χρέωση ακύρωσης σε περιπτώσεις:</p>
            <ul>
              <li>Ιατρικού επείγοντος (με προσκόμιση σχετικού εγγράφου)</li>
              <li>Ανωτέρας βίας (π.χ. ακραίες καιρικές συνθήκες)</li>
              <li>Σφάλματος από την πλευρά μας</li>
            </ul>
          </section>

          <section>
            <h2>3. Επιστροφές Χρημάτων για Υπηρεσίες</h2>

            <h3>3.1 Δικαίωμα Επιστροφής</h3>
            <p>Δικαιούστε πλήρη επιστροφή χρημάτων εάν:</p>
            <ul>
              <li>Η υπηρεσία δεν παρασχέθηκε σύμφωνα με τα συμφωνηθέντα</li>
              <li>Υπήρξε σημαντική απόκλιση από το αναμενόμενο αποτέλεσμα</li>
              <li>Η υπηρεσία δεν ξεκίνησε λόγω δικής μας υπαιτιότητας</li>
              <li>Υπάρχει προφανές σφάλμα στην εκτέλεση της υπηρεσίας</li>
            </ul>

            <h3>3.2 Μερική Επιστροφή</h3>
            <p>
              Σε ορισμένες περιπτώσεις, μπορεί να προσφερθεί μερική επιστροφή:
            </p>
            <ul>
              <li>Εάν μέρος της υπηρεσίας δεν παρασχέθηκε</li>
              <li>Εάν υπήρξε καθυστέρηση από την πλευρά μας</li>
              <li>
                Εάν χρησιμοποιήθηκαν διαφορετικά προϊόντα από τα συμφωνηθέντα
              </li>
            </ul>

            <h3>3.3 Διαδικασία Αίτησης Επιστροφής</h3>
            <p>Για να ζητήσετε επιστροφή χρημάτων:</p>
            <ol>
              <li>Ενημερώστε μας αμέσως μετά την παροχή της υπηρεσίας</li>
              <li>Περιγράψτε λεπτομερώς το πρόβλημα</li>
              <li>Παρέχετε φωτογραφίες εάν είναι δυνατόν</li>
              <li>Συμπληρώστε τη φόρμα επιστροφής (εάν απαιτείται)</li>
              <li>Περιμένετε την αξιολόγησή μας (εντός 48 ωρών)</li>
            </ol>
          </section>

          <section>
            <h2>4. Επιστροφές Προκαταβολών</h2>

            <h3>4.1 Πότε Απαιτείται Προκαταβολή</h3>
            <p>Προκαταβολή μπορεί να απαιτηθεί για:</p>
            <ul>
              <li>Ομαδικές κρατήσεις (3+ άτομα)</li>
              <li>Premium υπηρεσίες πολλαπλών ωρών</li>
              <li>Ειδικές εκδηλώσεις (γάμοι, φωτογραφίσεις κ.λπ.)</li>
              <li>Υπηρεσίες εκτός καταστήματος</li>
            </ul>

            <h3>4.2 Επιστροφή Προκαταβολών</h3>
            <p>Οι προκαταβολές επιστρέφονται ως εξής:</p>
            <ul>
              <li>
                <strong>Ακύρωση 7+ ημέρες πριν:</strong> 100% επιστροφή
              </li>
              <li>
                <strong>Ακύρωση 3-7 ημέρες πριν:</strong> 75% επιστροφή
              </li>
              <li>
                <strong>Ακύρωση 1-3 ημέρες πριν:</strong> 50% επιστροφή
              </li>
              <li>
                <strong>Ακύρωση εντός 24 ωρών:</strong> Καμία επιστροφή
              </li>
            </ul>

            <h3>4.3 Μεταφορά Προκαταβολής</h3>
            <p>
              Αντί για επιστροφή, μπορείτε να μεταφέρετε την προκαταβολή σε
              μελλοντική κράτηση εντός 6 μηνών.
            </p>
          </section>

          <section>
            <h2>5. Χρονοδιάγραμμα Επιστροφών</h2>

            <h3>5.1 Επεξεργασία Επιστροφής</h3>
            <p>Μετά την έγκριση της αίτησης επιστροφής:</p>
            <ul>
              <li>Επιστροφές σε κάρτες: 5-10 εργάσιμες ημέρες</li>
              <li>Επιστροφές σε τραπεζικό λογαριασμό: 3-7 εργάσιμες ημέρες</li>
              <li>Επιστροφές σε μετρητά: Άμεσα (στο κατάστημα)</li>
            </ul>

            <h3>5.2 Ειδοποίηση Επιστροφής</h3>
            <p>Θα λάβετε email επιβεβαίωσης όταν:</p>
            <ul>
              <li>Η αίτησή σας ληφθεί</li>
              <li>Η αίτησή σας εγκριθεί ή απορριφθεί</li>
              <li>Η επιστροφή επεξεργαστεί</li>
            </ul>
          </section>

          <section>
            <h2>6. Εναλλακτικές της Επιστροφής</h2>

            <h3>6.1 Επαναληπτική Υπηρεσία</h3>
            <p>
              Σε περίπτωση δυσαρέσκειας, προσφέρουμε δωρεάν επαναληπτική
              υπηρεσία για να διορθώσουμε το πρόβλημα. Αυτό πρέπει να γίνει
              εντός 7 ημερών από την αρχική υπηρεσία.
            </p>

            <h3>6.2 Πίστωση Καταστήματος</h3>
            <p>
              Αντί για επιστροφή χρημάτων, μπορείτε να επιλέξετε πίστωση
              καταστήματος με:
            </p>
            <ul>
              <li>10% επιπλέον αξία (π.χ. €50 γίνονται €55 πίστωση)</li>
              <li>Ισχύει για 12 μήνες</li>
              <li>Μπορεί να χρησιμοποιηθεί για οποιαδήποτε υπηρεσία</li>
            </ul>

            <h3>6.3 Δωρεάν Προϊόντα ή Υπηρεσίες</h3>
            <p>
              Σε ορισμένες περιπτώσεις, μπορεί να προσφέρουμε δωρεάν προϊόντα
              περιποίησης ή συμπληρωματικές υπηρεσίες ως αποζημίωση.
            </p>
          </section>

          <section>
            <h2>7. Πολιτική για Προϊόντα</h2>

            <h3>7.1 Αγορά Προϊόντων</h3>
            <p>Για προϊόντα grooming που αγοράζονται στο κατάστημα:</p>
            <ul>
              <li>Επιστροφή εντός 14 ημερών εάν δεν έχουν ανοιχτεί</li>
              <li>Τα προϊόντα πρέπει να είναι στην αρχική τους συσκευασία</li>
              <li>Απαιτείται απόδειξη αγοράς</li>
              <li>Αλλαγή σε άλλο προϊόν ή πλήρης επιστροφή</li>
            </ul>

            <h3>7.2 Ελαττωματικά Προϊόντα</h3>
            <p>Για ελαττωματικά ή κατεστραμμένα προϊόντα:</p>
            <ul>
              <li>Άμεση αντικατάσταση ή πλήρης επιστροφή</li>
              <li>Καμία χρονική προθεσμία για αναφορά ελαττώματος</li>
              <li>Δεν απαιτείται αρχική συσκευασία</li>
            </ul>
          </section>

          <section>
            <h2>8. Ειδικές Περιπτώσεις</h2>

            <h3>8.1 Πακέτα Υπηρεσιών</h3>
            <p>Για προπληρωμένα πακέτα υπηρεσιών:</p>
            <ul>
              <li>Επιστροφή για αχρησιμοποίητες υπηρεσίες εντός 90 ημερών</li>
              <li>Αναλογική επιστροφή με βάση την τιμή μονάδας</li>
              <li>Χρέωση διαχείρισης 10% για ακύρωση πακέτου</li>
            </ul>

            <h3>8.2 Κάρτες Δώρου</h3>
            <p>Οι κάρτες δώρου:</p>
            <ul>
              <li>Δεν επιστρέφονται σε μετρητά</li>
              <li>Ισχύουν για 24 μήνες από την ημερομηνία έκδοσης</li>
              <li>Μπορούν να μεταφερθούν σε άλλο άτομο</li>
              <li>
                Σε περίπτωση απώλειας, μπορούν να επανεκδοθούν με χρέωση €5
              </li>
            </ul>

            <h3>8.3 Εκπτωτικές Υπηρεσίες</h3>
            <p>Για υπηρεσίες που παρέχονται με έκπτωση ή προσφορά:</p>
            <ul>
              <li>Η επιστροφή υπολογίζεται στην εκπτωτική τιμή</li>
              <li>Ισχύουν οι ίδιοι όροι ακύρωσης</li>
              <li>Οι προσφορές δεν μπορούν να συνδυαστούν με επιστροφές</li>
            </ul>
          </section>

          <section>
            <h2>9. Διαδικασία Παραπόνων</h2>

            <h3>9.1 Πώς να Υποβάλετε Παράπονο</h3>
            <p>Εάν δεν είστε ικανοποιημένοι:</p>
            <ol>
              <li>Μιλήστε με τον manager του καταστήματος αμέσως</li>
              <li>
                Εάν δεν επιλυθεί, στείλτε email στο{" "}
                <a href="mailto:fapugo@hotmail.com">fapugo@hotmail.com</a>
              </li>
              <li>
                <a href="https://wa.me/302101234567">WhatsApp</a>
              </li>
              <li>
                <a href="https://viber.me/302101234567">Viber</a>
              </li>
              <li>Συμπεριλάβετε: όνομα, ημερομηνία, περιγραφή, φωτογραφίες</li>
              <li>Θα απαντήσουμε εντός 48 ωρών</li>
              <li>Η οριστική απάντηση θα δοθεί εντός 7 εργάσιμων ημερών</li>
            </ol>

            <h3>9.2 Κλιμάκωση</h3>
            <p>
              Εάν δεν είστε ικανοποιημένοι με την απάντησή μας, μπορείτε να
              απευθυνθείτε στη Γενική Γραμματεία Καταναλωτή ή σε άλλες αρμόδιες
              αρχές.
            </p>
          </section>

          <section>
            <h2>10. Δικαιώματα του Καταστήματος</h2>
            <p>Διατηρούμε το δικαίωμα να αρνηθούμε επιστροφή εάν:</p>
            <ul>
              <li>Δεν ακολουθήθηκε η σωστή διαδικασία</li>
              <li>Υπάρχουν ενδείξεις κατάχρησης της πολιτικής</li>
              <li>Το αίτημα υποβλήθηκε εκτός προθεσμίας</li>
              <li>Η υπηρεσία παρασχέθηκε σύμφωνα με τα συμφωνηθέντα</li>
              <li>
                Το πρόβλημα προκλήθηκε από τον πελάτη (π.χ. λανθασμένες οδηγίες)
              </li>
            </ul>
          </section>

          <section>
            <h2>11. Πολιτική Μη Εμφάνισης</h2>
            <p>Σε περίπτωση επαναλαμβανόμενων μη εμφανίσεων:</p>
            <ul>
              <li>
                Μετά την 2η μη εμφάνιση: Υποχρεωτική προκαταβολή για μελλοντικές
                κρατήσεις
              </li>
              <li>Μετά την 3η μη εμφάνιση: Δικαίωμα άρνησης κρατήσεων</li>
              <li>Οι μη εμφανίσεις καταγράφονται στο προφίλ σας</li>
            </ul>
          </section>

          <section>
            <h2>12. Τροποποίηση Κρατήσεων</h2>
            <p>Μπορείτε να τροποποιήσετε την κράτησή σας χωρίς χρέωση:</p>
            <ul>
              <li>Μέχρι 12 ώρες πριν από το ραντεβού</li>
              <li>Εφόσον υπάρχει διαθεσιμότητα στη νέα ημερομηνία/ώρα</li>
              <li>Για την ίδια υπηρεσία ή υπηρεσία παρόμοιας αξίας</li>
            </ul>
          </section>

          <section>
            <h2>13. Ευθύνη Πελάτη</h2>
            <p>Είναι δική σας ευθύνη:</p>
            <ul>
              <li>Να παρέχετε ακριβείς πληροφορίες επικοινωνίας</li>
              <li>Να ενημερώνετε για αλλαγές στα στοιχεία σας</li>
              <li>Να ενημερώνετε για ιατρικές καταστάσεις ή αλλεργίες</li>
              <li>Να διαβάζετε τα email επιβεβαίωσης</li>
              <li>Να ακυρώνετε εγκαίρως εάν δεν μπορείτε να παρουσιαστείτε</li>
            </ul>
          </section>

          <section>
            <h2>14. Εξαιρέσεις από την Πολιτική</h2>
            <p>Αυτή η πολιτική δεν ισχύει για:</p>
            <ul>
              <li>Ειδικές προσφορές με όρους "μη επιστρέψιμο"</li>
              <li>Flash sales ή προσφορές περιορισμένου χρόνου</li>
              <li>Υπηρεσίες που παρασχέθηκαν σε ειδικές εκδηλώσεις</li>
              <li>Συνεργασίες με τρίτους (όπου ισχύουν οι δικοί τους όροι)</li>
            </ul>
          </section>

          <section>
            <h2>15. Επικοινωνία για Επιστροφές</h2>
            <p>Για ερωτήσεις ή αιτήματα επιστροφής, επικοινωνήστε μαζί μας:</p>
            <ul>
              <li>
                <strong>Email:</strong>{" "}
                <a href="mailto:fapugo@hotmail.com">fapugo@hotmail.com</a>
              </li>
              <li>
                <a href="https://wa.me/302101234567">WhatsApp</a>
              </li>
              <li>
                <a href="https://viber.me/302101234567">Viber</a>
              </li>
              <li>
                <strong>Τηλέφωνο:</strong> +30 210 123 4567 (Δευ-Σαβ,
                09:00-20:00)
              </li>
              <li>
                <strong>Στο κατάστημα:</strong> Μιλήστε με τον manager
              </li>
              <li>
                <strong>Online:</strong> Μέσω της φόρμας επικοινωνίας στον
                ιστότοπο
              </li>
            </ul>
          </section>

          <section>
            <h2>16. Ενημερώσεις Πολιτικής</h2>
            <p>
              Διατηρούμε το δικαίωμα να τροποποιήσουμε αυτήν την πολιτική ανά
              πάσα στιγμή. Οι αλλαγές τίθενται σε ισχύ αμέσως μετά τη δημοσίευσή
              τους. Οι υφιστάμενες κρατήσεις διέπονται από την πολιτική που
              ίσχυε κατά τη στιγμή της κράτησης.
            </p>
          </section>

          <section className="policy-footer">
            <p>
              <strong>Σημείωση:</strong> Τα δικαιώματά σας ως καταναλωτή σύμφωνα
              με την ελληνική και ευρωπαϊκή νομοθεσία παραμένουν ανεπηρέαστα από
              αυτήν την πολιτική. Σε περίπτωση διαφοράς, υπερισχύει η νομοθεσία.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
